import actions from '@lib/analytics/emarsys/actions'

const { tagEvent } = actions

const view = (params: any) => {
  tagEvent('view-search-results', params)
}

export default {
  view,
}
